/**
 * Client-side trainer category filter on /trainer/. Only present at all
 * when the server decided there are enough trainers/categories to
 * justify it (template-parts/trainer/grid.php) — progressive
 * enhancement: without JS every trainer stays visible, the buttons are
 * simply inert.
 */
export function initTrainerFilter() {
  const wrapper = document.querySelector('[data-trainer-filter]');

  if (!wrapper) {
    return;
  }

  const buttons = wrapper.querySelectorAll('[data-trainer-filter-btn]');
  const cards = document.querySelectorAll('[data-trainer-categories]');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.getAttribute('data-trainer-filter-btn');

      buttons.forEach((btn) => {
        const active = btn === button;
        btn.classList.toggle('rsv-news-filters__item--active', active);
        btn.setAttribute('aria-pressed', String(active));
      });

      cards.forEach((card) => {
        const categories = card.getAttribute('data-trainer-categories').split(' ');
        const show = filter === 'alle' || categories.includes(filter);
        card.hidden = !show;
      });
    });
  });
}
